import FooterD5 from './FooterD5';

export default FooterD5;
